<template>
  <van-swipe :autoplay="5000" lazy-render>
    <van-swipe-item v-for="(item) in banners" :key="item.bulletin_id">
      <template v-if="isApp()">
        <van-image @click.stop="onBannerClick(item)" :src="item.subject" lazy-load />
      </template>
      <template v-else>
        <!-- <a class="d-block s-item" v-if="item.content" :href="item.content" target="_blank">
          <van-image :src="item.subject" lazy-load />
        </a> -->
        <van-image :src="item.subject" lazy-load @click="itemClick(item)" />
      </template>
    </van-swipe-item>
  </van-swipe>
  <!--弹窗公告-->
  <van-popup v-model:show="noticShow" class="notice-pup" @click-overlay.stop="close" @open="showdom = true"
    @closed="showdom = false" teleport="#app-container">
    <div class="dialog-notice" v-if="showdom">
      <div class="dialog-title-notice">
        <div class="title-main"></div>
      </div>
      <div class="dialog-content">
        <div class="dialog-main">
          <!--图片公告-->
          <van-image class="notice-swiper-img" :src="currentItem.subject" lazy-load />
          <div class="dialog-content-detail" :type="currentItem.content_type" v-html="currentItem.content"></div>
        </div>
      </div>
      <div class="notic-footer d-flex align-items-center justify-content-center">
        <p class="fz-14 text-ellipsis readed-txt" @click.stop="close" v-text="$t('我已了解')"></p>
      </div>
    </div>
  </van-popup>
</template>

<script lang="ts">
import { ref } from 'vue'
import {getBannerAndNotice} from "/@/hooks/message";
import {isApp} from "/@/kernel-mn/utils";
import { useHot } from '/@/kernel-mn/stores/useHot';
import {mb_APPJump} from "/@/plugins/global";
import {doJump} from "/@/plugins/jump";

export default {
  name: "Banner",
  setup() {
    const { activeConfiguration } = useHot();
    const {banners} = getBannerAndNotice();
    const onBannerClick = item => {
      const { content } = item;
      if (content) mb_APPJump(content);
    };
     // 显示弹窗
    const noticShow = ref(false);
    const showdom = ref(false);
    const currentItem = ref<any>({})
    const itemClick = (item)=>{
      console.log('banner-->itemClick:', item)
      if ([1, 2].includes(item.content_type) && item.link_type) {
        noticShow.value = true;
        showdom.value = true;
        currentItem.value = item;
      }else {
        doJump(item, activeConfiguration)
      }
    }
    const close = () => {
      noticShow.value = false;
    };
    return {
      onBannerClick,
      banners,
      isApp,
      itemClick,
      close,
      currentItem,
      noticShow,
      showdom
    }
  }
}
</script>

<style lang="scss" scoped>
.van-swipe {
  :deep(.van-swipe-item) {
    height: px2rem(130);
  }
  .s-item {
    display: block;width: 100%;height: 100%;
  }
  :deep(.van-image) {
    display: block;width: 100%;height: 100%;
    img {
      border-radius: px2rem(12);
    }
  }
  :deep(.van-swipe__indicators) {
    .van-swipe__indicator {
      width: px2rem(14);height: px2rem(6);border-radius: px2rem(3);
    }
  }
}

// 弹窗公告
.dialog-notice {
  width: px2rem(350);
  min-height: px2rem(420);
  max-height: 80vh;
  position: relative;
  color: var(--text_bg_color);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 46px 0px #41548A4D;

  .dialog-content {
    overflow-y: auto;
    padding: px2rem(10) 0;
    // flex: 1;
    // min-height: px2rem(250);
    background: #F1F6FB;
    position: relative;
    top: px2rem(-12);
    border-radius: px2rem(12) px2rem(12) 0 0;
  }

  .dialog-title-notice {
    height: px2rem(110);
    flex-shrink: 0;
  }

  .dialog-main {
    padding: 0 px2rem(10);
  }

  // 轮播图片公告
  .van-swipe {
    height: px2rem(220);
    border-radius: px2rem(12);

    .van-image {
      display: block;
      width: 100%;
      height: 100%;
    }

    :deep(.van-swipe__indicators) {
      .van-swipe__indicator {
        background: #d9d9d9;
      }

      .van-swipe__indicator--active {
        background: var(--primary);
      }
    }
  }

  // 文字公告
  .notice-collapse-box {
    margin-top: px2rem(10);

    :deep(.van-cell:not(.van-collapse-item__title--expanded)) {
      .van-cell__right-icon {
        &:before {
          transform: initial;
        }
      }
    }

    :deep(.van-cell) {
      height: px2rem(40);

      &.van-collapse-item__title--expanded {
        color: var(--primary);

        .van-cell__right-icon {
          color: var(--primary);
        }
      }
    }

    .notice-item {
      border-radius: px2rem(10);
      margin-bottom: px2rem(8);
      overflow: hidden;
      border: px2rem(1) solid transparent;
      transition: .2s;

      &:last-child {
        margin-bottom: 0;
      }

      &:has(> .van-collapse-item__title--expanded) {
        border-color: var(--primary);
      }

      :deep(.van-collapse-item__content) {
        padding: px2rem(10);
        line-height: 1.4;
        font-size: px2rem(14);
        word-break: break-word;
      }
    }
  }

  .notic-footer {
    background: #fff;
    height: px2rem(28);
    padding: px2rem(10) px2rem(14);
    position: relative;
    top: px2rem(-12);
    border-radius: 0 0 px2rem(12) px2rem(12);
    flex-shrink: 0;
  }

  .readed-txt {
    color: var(--primary);
  }
}

.themeKY28 {
  .dialog-notice {
    .title-main {
      width: 100%;
      height: 100%;
      @include bgFull(publicImgUrl('themeKY28/home/notice_title.png'));
      background-size: 100% auto;
    }
  }
}

.themeKYMN {
  .dialog-notice {
    .dialog-title-notice {
      height: px2rem(52);
    }

    .title-main {
      width: 100%;
      height: 100%;
      @include bgFull(publicImgUrl('themeKYMN/home/notice_title.png'));
      background-size: 100% auto;
    }

    .dialog-content {
      top: px2rem(-1);
      border-radius: px2rem(3) px2rem(3) 0 0;
      background: linear-gradient(180deg, #FFF9F2, #fff);
    }

    .dialog-main {
      padding-top: px2rem(5);
    }

    .notice-collapse-box {
      .notice-title-icon {
        width: px2rem(20);
        height: px2rem(20);
        margin-right: px2rem(5);
        flex-shrink: 0;
        background: url(publicImgUrl('themeKYMN/home/notice_icon_2.png')) 0 0 / 100% 100%;
      }

      :deep(.van-cell) {
        background: #FAFAFA;
        height: px2rem(46);
        border-radius: px2rem(6);

        .van-cell__right-icon {
          @include flexStyle();
          width: px2rem(20);
          height: px2rem(20);
          background: #F5F5F5;
          color: #666;
          border-radius: 50%;
          font-size: px2rem(14);
          text-align: center;
          transition: .2s;
        }
      }

      .notice-item {
        border: 0;
        border-radius: 0;
      }

      :deep(.van-collapse-item__content) {
        border-top: 0;
      }

      :deep(.van-collapse-item__title--expanded) {
        background: #FEF3E7;
        color: #333;
        border-radius: px2rem(6) px2rem(6) 0 0;

        .van-cell__right-icon {
          background: #F6B168;
          color: #fff;
        }

        .notice-title-icon {
          background-image: url(publicImgUrl('themeKYMN/home/notice_icon_2.png'));
        }
      }
    }

    .notic-footer {
      top: px2rem(-2);
      height: px2rem(36);
    }

    .readed-txt {
      padding: px2rem(6) px2rem(15);
      background: var(--primary);
      color: #fff;
      border-radius: px2rem(5);
      height: px2rem(24);
      line-height: px2rem(24);
      text-align: center;
    }

    .notice-bottom {
      margin-top: px2rem(10);
      display: flex;
      align-items: center;
      flex-direction: column;

      .van-checkbox {
        margin-bottom: px2rem(10);

        :deep(.van-checkbox__icon) {
          font-size: px2rem(16);
          background: #EAEAEA;
        }

        :deep(.van-checkbox__label) {
          color: #fff;
        }
      }
    }
  }
}
</style>